import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PackageApi from "../../api/PackageApi";

function View() {

  const { id } = useParams();

  const navigate = useNavigate();

  const [data, setData] = useState(null);

  useEffect(() => {

    fetchDetails();

  }, []);

  const fetchDetails = async () => {

    const res = await PackageApi.list();

    if (res.code === 200) {

      const found = res.data.find((x) => x._id === id);

      setData(found);

    }

  };

  if (!data) {
    return <div className="content">Loading...</div>;
  }

  return (
    <div className="content">

      {/* HEADER */}

      <div
        style={{
          background: "linear-gradient(135deg,#7c2d12,#991b1b)",
          borderRadius: "24px",
          padding: "40px",
          color: "#fff",
          marginBottom: "30px",
        }}
      >
        <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">

          <div>

            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                background: "rgba(255,255,255,0.15)",
                padding: "8px 16px",
                borderRadius: "40px",
                marginBottom: "20px",
                fontSize: "14px",
              }}
            >
              <i className="ti ti-package"></i>
              Package Details
            </div>

            <h1
              style={{
                fontSize: "42px",
                fontWeight: "800",
                marginBottom: "10px",
                color: "#fff",
              }}
            >
              {data.packageName}
            </h1>

            <p
              style={{
                opacity: ".9",
                maxWidth: "700px",
                fontSize: "16px",
              }}
            >
              Complete overview of this project package and included modules.
            </p>

          </div>

          <div className="d-flex gap-2">

            <button
              className="btn btn-light"
              onClick={() => navigate(-1)}
            >
              <i className="ti ti-arrow-left me-2"></i>
              Back
            </button>

          </div>

        </div>
      </div>

      {/* STATS */}

      <div className="row mb-4">

        <div className="col-md-4">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body">
              <h6>Total Modules</h6>

              <h2 className="fw-bold text-danger">
                {data.modules?.length || 0}
              </h2>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body">
              <h6>Status</h6>

              <h2 className="fw-bold text-success">
                Active
              </h2>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body">
              <h6>Created</h6>

              <h5 className="fw-bold">
                {new Date(data.createdAt).toLocaleDateString()}
              </h5>
            </div>
          </div>
        </div>

      </div>

      {/* MODULES */}

      <div className="card border-0 shadow-sm rounded-4">

        <div className="card-body">

          <div className="d-flex align-items-center justify-content-between mb-4">

            <h3 className="fw-bold mb-0">
              Included Modules
            </h3>

            <span className="badge bg-danger">
              {data.modules?.length} Modules
            </span>

          </div>

          <div className="row">

            {data.modules?.map((m, index) => (

              <div className="col-md-6 mb-4" key={index}>

                <div
                  style={{
                    border: "1px solid #eee",
                    borderRadius: "20px",
                    padding: "25px",
                    height: "100%",
                    background: "#fff",
                  }}
                >

                  <div
                    style={{
                      width: "55px",
                      height: "55px",
                      borderRadius: "16px",
                      background: "#fef2f2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <i
                      className="ti ti-box"
                      style={{
                        fontSize: "26px",
                        color: "#dc2626",
                      }}
                    ></i>
                  </div>

                  <h4
                    style={{
                      fontWeight: "700",
                      marginBottom: "14px",
                    }}
                  >
                    {m.moduleName}
                  </h4>

                  <p
                    style={{
                      color: "#6b7280",
                      lineHeight: "1.8",
                    }}
                  >
                    {m.description || "No description available"}
                  </p>

                </div>

              </div>

            ))}

          </div>

        </div>

      </div>

    </div>
  );
}

export default View;